export enum SUPERVISOR_MONITOR_LIST_MODULE {
  TO_BE_NOMINATED = 'TO_BE_NOMINATED',
  NON_PROPOSED_APPLICATION = 'NON_PROPOSED_APPLICATION',
  APPLICATION_LIST = 'APPLICATION_LIST',
  DELEGATE_LIST = 'DELEGATE_LIST',
  CO_SUPERVISOR_DECLARATION = 'CO_SUPERVISOR_DECLARATION',
  POLISH_COMMENTS = 'POLISH_COMMENTS',
  SCHOLARSHIP_MANAGEMENT = 'SCHOLARSHIP_MANAGEMENT',
}

export enum MappingType {
  COMPETITIVE = 'COMPETITIVE',
  OTHER = 'OTHER',
  NON_COMPETITIVE = 'NON_COMPETITIVE',
}
export const fundingTypeText: Record<MappingType, string> = {
  [MappingType.COMPETITIVE]: 'Competitive',
  [MappingType.NON_COMPETITIVE]: 'Non-competitive',
  [MappingType.OTHER]: 'DEA, Self-financed, Others',
};

export enum FUNDING_TAGS {
  GRF = 'GRF',
  STRATEGIC_GLOBAL = 'STRATEGIC_GLOBAL',

  NEED_ACCOUNT = 'NEED_ACCOUNT',
  // MOD 5/11/2024 this tag is just tailor-made for `Allocation of PhD...`
  // NEED_ACCOUNT_FOR_4_YEAR_PHD = 'NEED_ACCOUNT_FOR_4_YEAR_PHD',
  NEED_PANEL_ROUND = 'NEED_PANEL_ROUND',
  NEED_PROJECT_ROLE = 'NEED_PROJECT_ROLE',
  NEED_DEFAULT_ACCOUNT_FOR_FIRST_YEAR = 'NEED_DEFAULT_ACCOUNT_FOR_FIRST_YEAR',
  NEED_PROOF = 'NEED_PROOF',
  NEED_PROOF_PROJECT_RECORD = 'NEED_PROOF_PROJECT_RECORD',
  NEED_PROOF_RIO_EMAIL = 'NEED_PROOF_RIO_EMAIL',
  NEED_PROOF_GS_EMAIL = 'NEED_PROOF_GS_EMAIL',
  NEED_PROOF_RESEARCH_UNIT_EMAIL = 'NEED_PROOF_RESEARCH_UNIT_EMAIL',
  NEED_ABBV_RESERACH_UNIT = 'NEED_ABBV_RESERACH_UNIT',
  NEED_DECLARATION = 'NEED_DECLARATION',
  HOD_EXTERNAL_FUNDS_OR_DEA = 'HOD_EXTERNAL_FUNDS_OR_DEA',
  HOD_NON_STEM_NON_SHS = 'HOD_NON_STEM_NON_SHS',
  LEVEL_MPHIL = 'LEVEL_MPHIL',
  MODE_PART_TIME = 'MODE_PART_TIME',
  TYPE_DUAL = 'TYPE_DUAL',
  TYPE_JOINT = 'TYPE_JOINT',
}

export const fundingValidTags: FUNDING_TAGS[] = [
  // tags: proof of document
  FUNDING_TAGS.NEED_PROOF_GS_EMAIL,
  FUNDING_TAGS.NEED_PROOF_RIO_EMAIL,
  FUNDING_TAGS.NEED_PROOF_RESEARCH_UNIT_EMAIL,
  FUNDING_TAGS.NEED_PROOF_PROJECT_RECORD,

  // tags: accountCode
  FUNDING_TAGS.NEED_ACCOUNT,
  FUNDING_TAGS.NEED_DEFAULT_ACCOUNT_FOR_FIRST_YEAR,

  // tags: need project role
  FUNDING_TAGS.NEED_PROJECT_ROLE,

  // tags: need funding related declaration
  // TODO to be added: FUNDING_TAGS.NEED_DECLARATION
];

export enum INTERVIEW_MODE {
  TELEPHONE = 'TELEPHONE',
  VIDEO = 'VIDEO',
  IN_PERSON = 'IN_PERSON',
}

export enum INTERVIEW_PANEL_LANGUAGE {
  ENGLISH = 'ENGLISH',
  CHINESE_MANDARIN = 'CHINESE_MANDARIN',
  CHINESE_CANTONESE = 'CHINESE_CANTONESE',
  OTHERS = 'OTHERS',
}
